import type { CallStatus } from '@/api/callLogs'

export interface StatusStyle {
  /** Clé i18n manager.history.statuses.* */
  labelKey: string
  /** Classes Tailwind pour le badge complet (clair + sombre). */
  className: string
  dotClass: string
  /** Si le statut est "en cours" / animé. */
  pulse?: boolean
}

const STATUS_MAP: Record<string, StatusStyle> = {
  completed: {
    labelKey: 'completed',
    className:
      'bg-emerald-100 dark:bg-emerald-500/20 text-emerald-700 dark:text-emerald-300 ring-1 ring-emerald-500/20',
    dotClass: 'bg-emerald-500',
  },
  missed: {
    labelKey: 'missed',
    className:
      'bg-amber-100 dark:bg-amber-500/20 text-amber-700 dark:text-amber-300 ring-1 ring-amber-500/20',
    dotClass: 'bg-amber-500',
  },
  'no-answer': {
    labelKey: 'noAnswer',
    className:
      'bg-amber-100 dark:bg-amber-500/20 text-amber-700 dark:text-amber-300 ring-1 ring-amber-500/20',
    dotClass: 'bg-amber-500',
  },
  no_answer: {
    labelKey: 'noAnswer',
    className:
      'bg-amber-100 dark:bg-amber-500/20 text-amber-700 dark:text-amber-300 ring-1 ring-amber-500/20',
    dotClass: 'bg-amber-500',
  },
  busy: {
    labelKey: 'busy',
    className:
      'bg-red-100 dark:bg-red-500/20 text-red-700 dark:text-red-300 ring-1 ring-red-500/20',
    dotClass: 'bg-red-500',
  },
  failed: {
    labelKey: 'failed',
    className:
      'bg-red-100 dark:bg-red-500/20 text-red-700 dark:text-red-300 ring-1 ring-red-500/20',
    dotClass: 'bg-red-500',
  },
  canceled: {
    labelKey: 'canceled',
    className:
      'bg-slate-100 dark:bg-slate-700 text-slate-600 dark:text-slate-400 ring-1 ring-slate-200 dark:ring-slate-600',
    dotClass: 'bg-slate-400',
  },
  ringing: {
    labelKey: 'ringing',
    className:
      'bg-blue-100 dark:bg-blue-500/20 text-blue-700 dark:text-blue-300 ring-1 ring-blue-500/20',
    dotClass: 'bg-blue-500',
    pulse: true,
  },
  'in-progress': {
    labelKey: 'inProgress',
    className:
      'bg-blue-100 dark:bg-blue-500/20 text-blue-700 dark:text-blue-300 ring-1 ring-blue-500/20',
    dotClass: 'bg-blue-500',
    pulse: true,
  },
}

export function getStatusStyle(status: CallStatus): StatusStyle {
  return (
    STATUS_MAP[status] ?? {
      labelKey: 'other',
      className:
        'bg-slate-100 dark:bg-slate-700 text-slate-600 dark:text-slate-400 ring-1 ring-slate-200 dark:ring-slate-600',
      dotClass: 'bg-slate-400',
    }
  )
}
